export interface RequestStatusColor {
    notStarted: string;
    inProgress: string;
    pending: string;
    completed: string;
}

export interface StatusDefinition {
    nameEn: string;
    nameFr: string;
    color: string;
    isDefault: boolean;
    type?: string;
}

// Default status colors
export const DEFAULT_STATUS_COLORS: RequestStatusColor = {
    notStarted: '#808080', // Gray
    inProgress: '#64B5F6', // Blue
    pending: '#FFB74D', // Orange
    completed: '#81C784', // Green
};

// Default statuses
export const DEFAULT_STATUSES: StatusDefinition[] = [
    {
        nameEn: 'Not started',
        nameFr: 'Pas commencé',
        color: DEFAULT_STATUS_COLORS.notStarted,
        isDefault: true,
    },
    {
        nameEn: 'In progress',
        nameFr: 'En cours',
        color: DEFAULT_STATUS_COLORS.inProgress,
        isDefault: true,
    },
    {
        nameEn: 'Pending',
        nameFr: 'En attente',
        color: DEFAULT_STATUS_COLORS.pending,
        isDefault: true,
    },
    {
        nameEn: 'Completed',
        nameFr: 'Complété',
        color: DEFAULT_STATUS_COLORS.completed,
        isDefault: true,
    },
];
